import Form from "react-bootstrap/Form";
import Spinner from 'react-bootstrap/Spinner';
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import QRCode from "react-qr-code";

import { useNavigate } from "react-router-dom";
import { toPng } from 'html-to-image';
import download from 'downloadjs';

import {
  FiGlobe, FiLink, FiUpload, FiFolder, FiLayout,
  FiDownload, FiCheck, FiAlertCircle, FiMail,
  FiGrid, FiCheckCircle, FiInfo, FiAward,
} from 'react-icons/fi';

import { useEffect } from "react";
import { useState, useRef } from 'react';
import { useAuth } from '../lib/StAuthGiver';
import { getCurSiteId, callApi } from '../lib/Common_funcs.js';

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined ? 'aws' : 'staging');
const Tdebug = (WhichEnv != 'aws');

export const StDashSite2 = () => {
  const { loginAction } = useAuth();
  const { logOut } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false)
  const [siteName, setSiteName] = useState('');

  const [createFirst, setCreateFirst] = useState(false);
  const [tsUDet, setTsUDet] = useState(JSON.parse(localStorage.getItem("uDet")));
  const [customDomainEnabled, setCustomDomainEnabled] = useState((tsUDet.planDetails.customDomain > 0) || (tsUDet.planDetails.customDomain == true));
  const [customDomain, setCustomDomain] = useState('https://diamond.turbosteed.com');

  const [siteAccessible, setSiteAccessible] = useState(false);
  const [siteReloads, setSiteReloads] = useState(0);
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [contactStatus, setContactStatus] = useState('');


  const [showModal, setModalShow] = useState(false);
  const [ConfirmationModalShow, setConfirmationModalShow] = useState(false);
  const [modal, setmodal] = useState({
    title: "",
    message: "",
  });

  Tdebug && console.log(tsUDet);
  Tdebug && console.log(tsUDet.planDetails.customDomain);
  Tdebug && console.log(customDomainEnabled);

  const isMounted = useRef(false);

  const [uploadStatus, setUploadStatus] = useState('');
  const [zipStatus, setZipStatus] = useState('');
  const [siteRenameStatus, setSiteRenameStatus] = useState('');
  const [siteUploadStatus, setSiteUploadStatus] = useState('');

  const [newSiteName, setNewSiteName] = useState('');
  const [siteId, setSiteId] = useState(getCurSiteId() || '');
  const [curSiteName] = useState(localStorage.getItem("curSite") || '');

  const baseApiUrl = `https://${process.env.REACT_APP_HOST_URL}`

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);

  // Confirmation Modal handlers
  const confirmModalOpen = (e) => setConfirmationModalShow(true);
  const confirmModalClose = () => setConfirmationModalShow(false);


  const handleContactInputChange = (e) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactStatus('Sending message...');

    try {
      const response = await callApi('/contact/support', 'POST', {},
        JSON.stringify({
          ...contactForm,
          siteId: siteId,
          userId: tsUDet.userId
        })
      );

      if (response.httpStatus === 200) {
        setContactStatus('Message sent successfully! We will get back to you soon.');
        setContactForm({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => {
          setShowContactModal(false);
          setContactStatus('');
        }, 3000);
      } else {
        setContactStatus('Failed to send message. Please try again.');
      }
    } catch (error) {
      setContactStatus('Error sending message. Please try again later.');
    }
  };
  const reloadSite = () => {
    setSiteReloads(siteReloads + 1);
  }
  const handleFileChange = async (event) => {

    Tdebug && console.log(event);
    //Tdebug && console.log(JSON.stringify(event));

    const file = event.target.files[0];

    const validZipMimeTypes = [
      'application/zip',
      'application/x-zip-compressed',
      'application/x-zip',
      ''
    ];
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    if (!validZipMimeTypes.includes(file.type) && fileExtension !== '.zip') {
      setZipStatus('Please select a valid zip file.');
      return;
    }
    const formData = new FormData();

    const fileBlob = new Blob([file], { type: 'application/octet-stream' });
    formData.append('file', fileBlob, file.name)

    let respMsg = '';

    try {
      const acctSid = localStorage.getItem('turbosteedAcct');
      const act_e = localStorage.getItem('act_e');
      Tdebug && console.log("StDashSite: acctSid: " + acctSid);
      Tdebug && console.log("StDashSite: acctSid: " + act_e);
      setZipStatus('Uploading...');
      const rcJson = await callApi('/sitesizes/' + siteId + '/getUploadUrl', 'POST', {},
        JSON.stringify({
          fileName: file.name
        })
      );

      Tdebug && console.log(rcJson);

      if (rcJson.disposition == 'logout') {
        Tdebug && console.log("Now logging out");
        logOut();
      }

      if (rcJson.httpStatus != 200) {

        if (rcJson.disposition == 'retry') {
          Tdebug && console.log(rcJson.message);
          setZipStatus('Something went wrong, please retry...')
          // Handle retry.
        }
        else if (rcJson.disposition == 'abort') {
          // Handle error.
          Tdebug && console.log(rcJson.message);
          setZipStatus('Something went wrong.')

        }
        else if ((rcJson.disposition == 'change') ||
          (rcJson.disposition == 'resource exists')) {
          Tdebug && console.log(rcJson.message);
          setZipStatus(rcJson.message);
        }
        else if (rcJson.disposition == 'empty') {
          Tdebug && console.log(rcJson.message);
          Tdebug && console.log(rcJson);
          setZipStatus(rcJson.message);
        }

        // If the cookie has changed, update it.
        if (rcJson.respBody.etac) {
          loginAction(null, rcJson.etac);
        }

        return;
      }

      // If the cookie has changed, update it.
      if (rcJson.respBody.etac) {
        loginAction(null, rcJson.etac);
      }

      // All good, we are ready to process the URL.
      const uploadUrl = rcJson.respBody.uploadTo;
      Tdebug && console.log("Now uploading to: " + uploadUrl);

      const response = await fetch(uploadUrl,
        {
          method: 'PUT',
          headers: {
            //'Content-Type': 'application/octet-stream',
          },
          body: file
        }).then(async (response) => {
          Tdebug && console.log(response);
          Tdebug && console.log(response.headers);
          Tdebug && console.log(response.data);
          Tdebug && console.log(JSON.stringify(response));

          // PUT on s3 does not send a body. Hence, we are good with the header itself.
          //const jsonBody = await response.json();
          //Tdebug && console.log(jsonBody);

          if (response.ok == false) {
            setZipStatus("Error uploading file.");
            return;
          }

          return ({ message: 'Upload successful' });
        }).then(async (responseJson) => {
          Tdebug && console.log(responseJson);

          // Now, we need to unzip the file and make it live.
          //setZipStatus("File uploaded, now processing the file.");

          const rcJson = await callApi('/sites/' + siteId + '/upload', 'POST', {},
            JSON.stringify({
              s3Url: uploadUrl
            })
          );

          Tdebug && console.log(rcJson);

          if (rcJson.disposition == 'logout') {
            Tdebug && console.log("Now logging out");
            logOut();
          }

          if (rcJson.httpStatus != 200) {

            if (rcJson.disposition == 'retry') {
              Tdebug && console.log(rcJson.message);
              setZipStatus('Something went wrong, please retry...')
              // Handle retry.
            }
            else if (rcJson.disposition == 'abort') {
              // Handle error.
              Tdebug && console.log(rcJson.message);
              setZipStatus('Something went wrong.')

            }
            else if ((rcJson.disposition == 'change') ||
              (rcJson.disposition == 'resource exists')) {
              Tdebug && console.log(rcJson.message);
              setZipStatus(rcJson.message);
            }
            else if (rcJson.disposition == 'empty') {
              Tdebug && console.log(rcJson.message);
              Tdebug && console.log(rcJson);
              setZipStatus(rcJson.message);
            }

            // If the cookie has changed, update it.
            if (rcJson.respBody.etac) {
              loginAction(null, rcJson.etac);
            }

            return;
          }

          // If the cookie has changed, update it.
          if (rcJson.respBody.etac) {
            loginAction(null, rcJson.etac);
          }

          setSiteAccessible(true);
          reloadSite();

          setZipStatus("Upload successful. Please refresh your page after 5 minutes...");
        })
    } catch (error) {
      setZipStatus('Error during upload: ' + error.message);

      console.log(error);
      setZipStatus(respMsg);
    }
  }

  const updateSiteName = async (event) => {
    Tdebug && console.log("updateSiteName: event is: " + event);

    const acctSid = localStorage.getItem('turbosteedAcct');
    const act_e = localStorage.getItem('act_e');

    Tdebug && console.log("StDashSite: acctSid: " + acctSid);
    Tdebug && console.log("StDashSite: acctSid: " + act_e);
    Tdebug && console.log("StDashSite: Site ID is" + siteId);
    Tdebug && console.log("StDashSite: new name is: " + newSiteName);

    if ((!siteId.length) && (createFirst == false)) {
      return;
    }

    if (!newSiteName.length) {
      Tdebug && console.log("Empty site name!")
      setmodal({
        title: 'Error',
        message: 'Site name cannot be empty'
      })
      return handleShow()
    }

    setLoading2(true)

    try {
      const response = await fetch(baseApiUrl + '/users/' + acctSid + (siteId.length ? ('/sites/' + siteId) : ('/sites')),
        {
          method: 'PUT',
          withCredentials: 'true',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + btoa(acctSid + ':' + act_e)
          },
          body: JSON.stringify({
            siteName: newSiteName
          })
        }).then((response) => {
          Tdebug && console.log(response);

          if (response.status === 400) {
            console.log("The site name should be greater than 3 characters")
            setmodal({
              title: 'Error',
              message: 'Site name must be more than 3 characters'
            })
            return handleShow()
          }

          if (response.status === 200) {
            setmodal({
              title: "Success",
              message:
                "Your site name has been updated",
            });
            handleShow();
          }

          Tdebug && console.log(response.headers);
          Tdebug && console.log(response.data);
          Tdebug && console.log(JSON.stringify(response));

          const jsonBody = response.json();
          console.log("JSON BODY:", jsonBody)
          if ((jsonBody.etac !== undefined) && (jsonBody.etac !== null)) {
            let encAuth = jsonBody.etac;
            loginAction(null, encAuth);
          }

          if (response.ok == false) {
            throw new Error(jsonBody);
          }

          return jsonBody;
        }).then((responseJson) => {
          Tdebug && console.log(responseJson);

          if ((responseJson.etac !== undefined) && (responseJson.etac !== null)) {
            let encAuth = responseJson.etac;
            loginAction(null, encAuth);
          }

          if (createFirst == true) {
            siteId = responseJson.siteId;
            setSiteId(siteId);
            setCreateFirst(false);
            setSiteName(newSiteName);
          }
          else {
            setSiteName(responseJson.siteName);
            console.log("This is the siteName", responseJson.siteName)
          }

          const curSiteIdx = localStorage.getItem('curSiteIdx');
          let currentSites = JSON.parse(localStorage.getItem("sites"));

          Tdebug && console.log(curSiteIdx);
          Tdebug && console.log(currentSites);

          currentSites[curSiteIdx]["siteName"] = responseJson.siteName;
          localStorage.setItem("sites", JSON.stringify(currentSites));
          localStorage.setItem("curSite", responseJson.siteName)

          const uDet = JSON.parse(localStorage.getItem("uDet"));

          console.log("uDet: ", uDet)

          if (uDet && uDet.sites && uDet.sites.length > 0) {
            console.log("uDet Condition True")
            console.log(uDet.sites)
            uDet.sites[0].siteName = responseJson.siteName;
            // 👈 new name here
          }

          console.log("After chaning uDet: ", uDet.sites[0].siteName)

          localStorage.setItem("uDet", JSON.stringify(uDet))

          console.log("Local Storage CurSite: ", localStorage.getItem("curSite"))
          Tdebug && console.log(currentSites);

          Tdebug && console.log(siteName);
          Tdebug && console.log(siteId);
        }).catch((error) => {
          console.log("Error caught in site rename: ", JSON.stringify(error));
          Tdebug && console.log(error);
          Tdebug && console.log("Will not take action!");

          logOut();
        });
    } catch (axe) {
      Tdebug && console.log(axe);
      setSiteRenameStatus(axe.message);
    } finally {
      setLoading2(false)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const curSiteId = getCurSiteId();
      const rcJson = await callApi('/sites/' + curSiteId, 'GET', {}, {});

      Tdebug && console.log(rcJson);

      console.log(rcJson)
      setSiteName(rcJson.respBody.siteName);

      if (rcJson.respBody.customDomain !== undefined) {
        Tdebug && console.log('rcJson.respBody.customDomain');
        setCustomDomain(rcJson.respBody.customDomain);
      }

      Tdebug && console.log(customDomain);

      Tdebug && console.log("Set loading to false as we have the information");
      console.log("customDomain Site Settings: ", customDomain)
      setLoading(false);
    }
    fetchData()
    console.log("sitenmae", siteName)
  }, []);

  async function downloadQRCode() {
    try {
      toPng(document.getElementById('qr_container'))
        .then(dataUrl => download(dataUrl, 'qr-code.png'))
    } catch (error) {
      alert(error)
    }
  }

  if (loading) {
    return (
      <div className="app-content" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center' }}>
          <Spinner animation="border" style={{ width: '2rem', height: '2rem', color: 'var(--accent-primary)' }} />
          <div style={{ marginTop: '12px', fontSize: '13px', color: 'var(--text-tertiary)' }}>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-content animate-in">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Site Settings</h1>
        <p className="dashboard-subtitle">Manage your website configuration and deployment settings</p>
      </div>

      {/* Warning banner */}
      <div style={{
        background: 'var(--warning-soft)', border: '1px solid rgba(245,158,11,0.2)',
        borderRadius: 'var(--radius-md)', padding: '12px 16px', marginBottom: '24px',
        display: 'flex', alignItems: 'center', gap: '12px', fontSize: '13px', color: 'var(--text-primary)',
      }}>
        <FiAlertCircle size={16} style={{ color: 'var(--warning)', flexShrink: 0 }} />
        <span>Site name changes may take up to 10 minutes to take effect. If you are using a template, open the site editor after 10 minutes and save again.</span>
      </div>

      <div className="bento-grid">

        {/* Site Configuration */}
        <div className="bento-card" style={{ gridColumn: 'span 8' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <div className="stat-card-icon"><FiGlobe size={18} /></div>
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 600, margin: 0 }}>Site Configuration</h3>
              <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', margin: 0 }}>Update your site name and domain settings</p>
            </div>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: 500, marginBottom: '6px', color: 'var(--text-primary)' }}>
              Site Name
            </label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <div style={{ flex: 1, display: 'flex' }}>
                <input
                  type="text"
                  placeholder={siteName || 'Enter your site name'}
                  onChange={(e) => setNewSiteName(e.target.value)}
                  style={{
                    flex: 1, padding: '9px 14px', border: '1px solid var(--border-color)',
                    borderRadius: 'var(--radius-md) 0 0 var(--radius-md)', fontSize: '14px',
                    background: 'var(--bg-primary)', color: 'var(--text-primary)',
                    outline: 'none', fontFamily: 'inherit',
                  }}
                />
                <span style={{
                  padding: '9px 14px', background: 'var(--bg-tertiary)',
                  border: '1px solid var(--border-color)', borderLeft: 'none',
                  borderRadius: '0 var(--radius-md) var(--radius-md) 0',
                  fontSize: '13px', color: 'var(--text-secondary)',
                }}>
                  .{process.env.REACT_APP_HOST_DOMAIN}
                </span>
              </div>
              <button
                onClick={(e) => confirmModalOpen(e)}
                style={{
                  padding: '9px 18px', background: 'var(--accent-gradient)', color: 'white',
                  border: 'none', borderRadius: 'var(--radius-md)', fontSize: '13px',
                  fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap',
                  display: 'flex', alignItems: 'center', gap: '6px',
                }}
              >
                {loading2 ? <Spinner animation="border" style={{ width: '14px', height: '14px', borderWidth: '2px' }} /> : null}
                {createFirst ? 'Create Site' : 'Update Site'}
              </button>
            </div>
            {siteRenameStatus.length > 0 && (
              <div style={{ marginTop: '8px', fontSize: '12px', color: 'var(--error)' }}>{siteRenameStatus}</div>
            )}
          </div>
        </div>

        {/* Custom Domain */}
        <div className="bento-card" style={{ gridColumn: 'span 4' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <div className={`stat-card-icon ${customDomainEnabled ? 'stat-card-icon--success' : 'stat-card-icon--warning'}`}>
              {customDomainEnabled ? <FiLink size={18} /> : <FiAward size={18} />}
            </div>
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 600, margin: 0 }}>Custom Domain</h3>
              <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', margin: 0 }}>
                {customDomainEnabled ? 'Connect your own domain' : 'Upgrade to use custom domains'}
              </p>
            </div>
          </div>

          {customDomainEnabled ? (
            customDomain && customDomain.length > 0 ? (
              <div style={{
                padding: '12px', background: 'var(--success-soft)',
                borderRadius: 'var(--radius-md)', overflow: 'hidden',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{
                    width: '28px', height: '28px', borderRadius: '50%', background: 'var(--success)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', flexShrink: 0,
                  }}>
                    <FiCheck size={14} />
                  </div>
                  <div style={{ minWidth: 0 }}>
                    <div style={{
                      fontSize: '13px', fontWeight: 500,
                      overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                    }}>
                      {customDomain}
                    </div>
                    <div style={{ fontSize: '12px', color: 'var(--text-tertiary)' }}>Domain is active</div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '16px 0' }}>
                <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginBottom: '12px' }}>No custom domain configured yet</p>
                <button
                  onClick={() => setShowContactModal(true)}
                  style={{
                    padding: '8px 16px', background: 'transparent', border: '1px solid var(--border-color)',
                    borderRadius: 'var(--radius-md)', fontSize: '13px', fontWeight: 500,
                    cursor: 'pointer', fontFamily: 'inherit', color: 'var(--text-primary)',
                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                  }}
                >
                  <FiMail size={14} /> Contact Us
                </button>
              </div>
            )
          ) : (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginBottom: '12px' }}>Custom domains are available with premium plans</p>
              <button
                onClick={() => setShowContactModal(true)}
                style={{
                  padding: '8px 16px', background: 'transparent', border: '1px solid var(--border-color)',
                  borderRadius: 'var(--radius-md)', fontSize: '13px', fontWeight: 500,
                  cursor: 'pointer', fontFamily: 'inherit', color: 'var(--text-primary)',
                  display: 'inline-flex', alignItems: 'center', gap: '6px',
                }}
              >
                <FiMail size={14} /> Contact Us
              </button>
            </div>
          )}
        </div>

        {/* Deploy */}
        <div className="bento-card" style={{ gridColumn: 'span 8' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <div className="stat-card-icon"><FiUpload size={18} /></div>
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 600, margin: 0 }}>Deploy Your Website</h3>
              <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', margin: 0 }}>Upload content or start with a template</p>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            {/* Upload Zone */}
            <div style={{
              border: '2px dashed var(--border-color)', borderRadius: 'var(--radius-lg)',
              padding: '28px', textAlign: 'center', cursor: 'pointer',
              transition: 'border-color 150ms ease',
            }}>
              <FiFolder size={28} style={{ color: 'var(--accent-primary)', marginBottom: '10px' }} />
              <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>Upload Zip</h4>
              <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginBottom: '12px' }}>Upload your zip website file here</p>
              <input type="file" accept=".zip" id="zipUploadInput" onChange={handleFileChange} style={{ display: 'none' }} />
              <button
                onClick={() => document.getElementById('zipUploadInput').click()}
                style={{
                  padding: '7px 16px', background: 'transparent', border: '1px solid var(--border-color)',
                  borderRadius: 'var(--radius-md)', fontSize: '13px', fontWeight: 500,
                  cursor: 'pointer', fontFamily: 'inherit', color: 'var(--text-primary)',
                  display: 'inline-flex', alignItems: 'center', gap: '6px',
                }}
              >
                <FiFolder size={13} /> Choose Zip
              </button>
              {zipStatus.length > 0 && (
                <div style={{
                  marginTop: '10px', fontSize: '12px',
                  color: zipStatus.includes('successful') ? 'var(--success)' : 'var(--accent-primary)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                }}>
                  {zipStatus.includes('successful')
                    ? <FiCheckCircle size={13} />
                    : <Spinner animation="border" style={{ width: '12px', height: '12px', borderWidth: '2px' }} />
                  }
                  {zipStatus}
                </div>
              )}
            </div>

            {/* Template Zone */}
            <div style={{
              background: 'var(--accent-soft)', borderRadius: 'var(--radius-lg)',
              padding: '28px', textAlign: 'center',
            }}>
              <FiLayout size={28} style={{ color: 'var(--accent-primary)', marginBottom: '10px' }} />
              <h4 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>Use Template</h4>
              <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginBottom: '12px' }}>Start with a professional template and customize</p>
              <button
                onClick={() => navigate(`/${siteId}/editor`)}
                style={{
                  padding: '7px 16px', background: 'var(--accent-gradient)', color: 'white',
                  border: 'none', borderRadius: 'var(--radius-md)', fontSize: '13px',
                  fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
                }}
              >
                Browse Templates
              </button>
            </div>
          </div>
        </div>

        {/* QR Code */}
        <div className="bento-card" style={{ gridColumn: 'span 4', textAlign: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <div className="stat-card-icon"><FiGrid size={18} /></div>
            <div style={{ textAlign: 'left' }}>
              <h3 style={{ fontSize: '15px', fontWeight: 600, margin: 0 }}>Share Your Site</h3>
              <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', margin: 0 }}>Scan or download QR code</p>
            </div>
          </div>
          <div id="qr_container" style={{ background: 'white', padding: '16px', borderRadius: 'var(--radius-md)', display: 'inline-block', marginBottom: '16px' }}>
            <QRCode
              value={customDomain !== '' ? customDomain : `https://${curSiteName}.${process.env.REACT_APP_HOST_DOMAIN}/index.html`}
              size={150}
            />
          </div>
          <div>
            <button
              onClick={downloadQRCode}
              style={{
                width: '100%', padding: '9px', background: 'transparent',
                border: '1px solid var(--border-color)', borderRadius: 'var(--radius-md)',
                fontSize: '13px', fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit',
                color: 'var(--text-primary)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', gap: '6px',
              }}
            >
              <FiDownload size={14} /> Download QR Code
            </button>
          </div>
        </div>
      </div>

      {/* Contact Support Modal */}
      <Modal show={showContactModal} onHide={() => setShowContactModal(false)} centered dialogClassName="modern-modal">
        <Modal.Header closeButton>
          <Modal.Title><FiMail size={15} className="me-2" />Contact Support</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleContactSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <Form.Group>
                <Form.Label>Name *</Form.Label>
                <Form.Control type="text" name="name" value={contactForm.name} onChange={handleContactInputChange} placeholder="Your full name" required />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email *</Form.Label>
                <Form.Control type="email" name="email" value={contactForm.email} onChange={handleContactInputChange} placeholder="your.email@example.com" required />
              </Form.Group>
            </div>
            <Form.Group className="mb-3">
              <Form.Label>Subject *</Form.Label>
              <Form.Control type="text" name="subject" value={contactForm.subject} onChange={handleContactInputChange} placeholder="What can we help you with?" required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Message *</Form.Label>
              <Form.Control as="textarea" rows={4} name="message" value={contactForm.message} onChange={handleContactInputChange} placeholder="Please describe your request in detail..." required />
            </Form.Group>
            {contactStatus && (
              <div style={{
                display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 14px',
                borderRadius: 'var(--radius-md)', fontSize: '13px',
                background: contactStatus.includes('success') ? 'var(--success-soft)' : 'var(--accent-soft)',
                color: contactStatus.includes('success') ? 'var(--success)' : 'var(--accent-primary)',
              }}>
                {contactStatus.includes('success') ? <FiCheckCircle size={14} /> : <FiInfo size={14} />}
                {contactStatus}
              </div>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowContactModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleContactSubmit} disabled={contactStatus.includes('Sending')}>
            {contactStatus.includes('Sending') ? 'Sending...' : 'Send Message'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Message Modal */}
      <Modal show={showModal} onHide={handleClose} centered dialogClassName="modern-modal">
        <Modal.Header closeButton>
          <Modal.Title>{modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>OK</Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <Modal show={ConfirmationModalShow} onHide={confirmModalClose} centered dialogClassName="modern-modal">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Name Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Site name changes may take up to 10 minutes to take effect. If you are using a template, please open the site editor after 10 minutes and save again.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={confirmModalClose}>Cancel</Button>
          <Button variant="primary" onClick={(e) => { updateSiteName(e); confirmModalClose(); }}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default StDashSite2;
